angular.module("ainapp")
    .controller("warehouseLedgerController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Warehouse Wise Ledger";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Brands = [];
            MainService.BrandsInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Brands = response.data;
                $scope.Brands.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.Categories = [];
            MainService.ProductsParentList("Product").then(function (response) {
                $scope.Categories = response.data;
            });

            $scope.GetSub = function () {
                $scope.Parents = [];
                MainService.ProductSubList($scope.filter.ProductGroupId, "Product").then(function (response) {
                    $scope.Parents = response.data;
                });
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {

                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                };
                                o.data.filter.filters.push(temp);
                            }
                        }

                        MainService.productForMultiSelect(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            //toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 50
            };

            $scope.selectProductsOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                filter: "contains",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };

            $scope.selectProductCodeOptions = {
                placeholder: "Select Product Codes...",
                dataTextField: "ProductCode",
                dataValueField: "Id",
                filter: "contains",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };


            $scope.warehouseSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        MainService.WarehouseInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            //toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 20
            };

            $scope.selectWarehouseOptions = {
                placeholder: "Select Warehouse...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.warehouseSelectDataSource
            };

             $scope.$on('$includeContentLoaded', function (event, templateName) {
                if (templateName === 'templates/common/stockFilterModal.html') {
                    $('#filterModal').modal('show');
                }
            });

            $scope.Init = function () {
 
                $scope.date1 = new Date();
                var n = $scope.date1.getFullYear();
                $scope.d2 = new Date("01/01/" + n);

                $scope.filter = {
                    FromDate: $scope.d2,
                    ToDate: new Date(),
                    ProductIds: [],
                    WarehouseIds: [],
                    isLoad: false,
                    Keyword: "",
                    BranchId: "",
                }

            }
            $scope.Init();




            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        if ($scope.filter.isLoad) {


                            o.data.FromDate = $scope.filter.FromDate;
                            o.data.ToDate = $scope.filter.ToDate;
                            o.data.ProductIds = $scope.filter.ProductIds;
                            o.data.WarehouseIds = $scope.filter.WarehouseIds;
                            o.data.Keyword = $scope.filter.Keyword;
                            o.data.BranchId = $scope.filter.BranchId;
                            o.data.ProductGroupId = $scope.filter.ProductGroupId;
                            o.data.ProductParentId = $scope.filter.ProductParentId;

                            o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                            o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                            MainService.StockLedger(o.data).then(function (response) {
                                $scope.totalBalanceQty = response.data.TotalBalanceQty;
                                $scope.totalBalanceValue = kendo.toString(response.data.TotalBalanceValue, '0.000');
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    },

                },
                change: function (data) {
                    if (data.items.length > 0) {
                        data.sender._aggregateResult.BalanceQty.count = 0;
                        angular.forEach(data.items, function (e) {

                            angular.forEach(e.items, function (aa) {
                                aa.aggregates.BalanceQty.count = Math.abs(aa.aggregates.ReceiptQty.sum - aa.aggregates.IssueQty.sum);
                                aa.aggregates.BalanceQty.count = Math.round(aa.aggregates.BalanceQty.count * 100) / 100;
                                var avgrate = 0;
                                angular.forEach(aa.items, function (a) {
                                    avgrate = a.AvgRate;
                                })
                                aa.aggregates.BalanceValue.count = avgrate * aa.aggregates.BalanceQty.count;
                                aa.aggregates.BalanceValue.count = Math.round(aa.aggregates.BalanceValue.count * 100) / 100;
                            })

                            e.aggregates.BalanceQty.count = Math.abs(e.aggregates.ReceiptQty.sum - e.aggregates.IssueQty.sum);
                            e.aggregates.BalanceQty.count = Math.round(e.aggregates.BalanceQty.count * 100) / 100;
                            e.aggregates.BalanceValue.count = "";
                        })
                        data.sender._aggregateResult.BalanceQty.count = Math.abs(data.sender._aggregateResult.ReceiptQty.sum - data.sender._aggregateResult.IssueQty.sum);
                        data.sender._aggregateResult.BalanceQty.count = Math.round(data.sender._aggregateResult.BalanceQty.count * 100) / 100;
                        data.sender._aggregateResult.BalanceValue.count = "";
                    }
                },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Product.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Product.ProductCode": {
                                type: "string",
                                editable: false,
                            },
                            "Account.Name": {
                                type: "string",
                                editable: false,
                            },
                            IssueQty: {
                                type: "number",
                                editable: false,
                            },
                            IssueRate: {
                                type: "number",
                                editable: false,
                            },
                            IssueValue: {
                                type: "number",
                                editable: false,
                            },
                            "IssueUnit.Name": {
                                type: "number",
                                editable: false,
                            },
                            ReceiptQty: {
                                type: "number",
                                editable: false,
                            },
                            ReceiptRate: {
                                type: "number",
                                editable: false,
                            },
                            ReceiptValue: {
                                type: "number",
                                editable: false,
                            },
                            "ReceiptUnit.Name": {
                                type: "number",
                                editable: false,
                            },
                            VoucherNo: {
                                type: "string",
                                editable: false,
                            },
                            "Warehouse.Name": {
                                type: "string",
                                editable: false,
                            },
                            Type: {
                                type: "string",
                                editable: false,
                            },
                            COGS: {
                                type: "number",
                                editable: false,
                            },
                            AvgRate: {
                                type: "number",
                                editable: false,
                            },
                            BalanceQty: {
                                type: "number",
                                editable: false,
                            },
                            BalanceValue: {
                                type: "number",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            ReciveQty: {
                                type: "number",
                                editable: false,
                            },

                        }
                    }
                },

                group: [{
                    field: "Warehouse.Name",
                    aggregates: [
                        {
                            field: "ReceiptQty",
                            aggregate: "sum"
                        },
                        {
                            field: "IssueQty",
                            aggregate: "sum"
                        },
                        {
                            field: "BalanceValue",
                            aggregate: "count"
                        },
                        {
                            field: "BalanceQty",
                            aggregate: "count"
                        },
                        {
                            field: "Type",
                            aggregate: "count"
                        }
                    ]
                }, {
                    field: "Product.Name",
                    aggregates: [
                        {
                            field: "ReceiptQty",
                            aggregate: "sum"
                        },
                        {
                            field: "IssueQty",
                            aggregate: "sum"
                        },
                        {
                            field: "BalanceValue",
                            aggregate: "count"
                        },
                        {
                            field: "BalanceQty",
                            aggregate: "count"
                        },
                        {
                            field: "Type",
                            aggregate: "count"
                        }
                    ]
                }],
                aggregate: [{
                    field: "ReceiptQty",
                    aggregate: "sum"
                },
                {
                    field: "IssueQty",
                    aggregate: "sum"
                },
                {
                    field: "BalanceValue",
                    aggregate: "count"
                },
                {
                    field: "BalanceQty",
                    aggregate: "count"
                },
                {
                    field: "Type",
                    aggregate: "count"
                }],

                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                selectable: true,
                sortable: true,
                scrollable: true,
                filterable: false,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                dataBound: onDataBound,


                columns: [
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "100px"
                    },
                    {
                        field: "Product.Name",
                        title: "Product",
                        hidden: true,
                        width: "150px"
                    },
                    {
                        field: "Product.ProductCode",
                        title: "Product Code",
                        hidden: true,
                        width: "150px"
                    },
                    //                    {
                    //                        field: "Account.Name",
                    //                        title: "Account ",
                    //                        width: "120px"
                    //                        },
                    {
                        field: "Type",
                        title: "Type",
                        width: "120px"
                    },
                    {
                        field: "VoucherNo",
                        title: "Doc No",
                        width: "100px"
                    },
                    {
                        field: "Warehouse.Name",
                        title: "Warehouse",
                        width: "100px",
                        hidden: true,
                    },

                    {
                        field: "ReceiptQty",
                        title: "Rec  Qty",
                        width: "100px",
                        template: "<div ng-if='dataItem.ReceiptQty !=  0' style='text-align: right'>#=kendo.toString(ReceiptQty, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                    },
                    //                    {
                    //                        field: "ReceiptRate",
                    //                        title: "Rec  Rate",
                    //                        width: "100px",
                    //                        template: "<div ng-if='dataItem.ReceiptRate !=  0'  style='text-align: right'>#=kendo.toString(ReceiptRate, 'n')#</div>",
                    //                        },
                    //                    {
                    //                        field: "ReceiptValue",
                    //                        title: "Rec  Value",
                    //                        width: "100px",
                    //                        template: "<div ng-if='dataItem.ReceiptValue !=  0' style='text-align: right'>#=kendo.toString(ReceiptValue, 'n')#</div>",
                    //                        },
                    //                    {
                    //                        field: "ReceiptUnit.Name",
                    //                        title: "Rec  Unit",
                    //                        width: "150px"
                    //                        },

                    {
                        field: "IssueQty",
                        title: "Issue  Qty",
                        width: "100px",
                        template: "<div ng-if='dataItem.IssueQty !=  0' style='text-align: right'>#=kendo.toString(IssueQty, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                    },
                    //                    {
                    //                        field: "IssueRate",
                    //                        title: "Issue  Rate",
                    //                        width: "100px",
                    //                        template: "<div ng-if='dataItem.IssueRate != 0' style='text-align: right'>#=kendo.toString(IssueRate, 'n')#</div>",
                    //                        },
                    //                    {
                    //                        field: "IssueValue",
                    //                        title: "Issue  Value",
                    //                        width: "100px",
                    //                        template: "<div ng-if='dataItem.IssueValue != 0' style='text-align: right'>#=kendo.toString(IssueValue, 'n')#</div>",
                    //                        },
                    //                    {
                    //                        field: "IssueUnit.Name",
                    //                        title: "Issue  Unit",
                    //                        width: "150px"
                    //                        },

                    //                    {
                    //                        field: "COGS",
                    //                        title: "COGS",
                    //                        width: "100px",
                    //                        template: "<div ng-if='dataItem.COGS != 0'  style='text-align: right'>#=kendo.toString(COGS, 'n')#</div>",
                    //                        },
                    {
                        field: "BalanceQty",
                        title: "Balance",
                        width: "100px",
                        template: "<div ng-if='dataItem.BalanceQty != 0' style='text-align: right'>#=kendo.toString(BalanceQty, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(count, 'n')#",
                        footerTemplate: "#=kendo.toString(count, 'n')#",
                    },
                    {
                        field: "AvgRate",
                        title: "Avg Rate",
                        width: "100px",
                        template: "<div ng-if='dataItem.AvgRate != 0' style='text-align: right'>#=kendo.toString(AvgRate, 'n')#</div>",
                    },
                    {
                        field: "BalanceValue",
                        title: "Balance Value",
                        width: "100px",
                        template: "<div ng-if='dataItem.BalanceValue != 0' style='text-align: right'>#=kendo.toString(BalanceValue, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(count, 'n')#",
                        footerTemplate: "#=kendo.toString(count, 'n')#",
                    },

                ],
            };

            function onDataBound() {
                var grid = this;
                grid.element.on('dblclick', 'tbody tr[data-uid]', function (e) {
                    grid = $("#Kendo-Grid").data("kendoGrid");
                    var selectedData = grid.dataItem(grid.select());
                    $scope.goLegerVoucher(selectedData);
                })
            }


           $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.filterData = function () {
                $scope.filter.isLoad = true;
                $('#filterModal').modal('hide');
                console.log($scope.filter)
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refreshData = function () {
                $scope.Init();
                $('#filterModal').modal('show');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.goLegerVoucher = function (selectedData) {

                console.log(selectedData)

                if (selectedData.Type == "Sales Invoice") {

                    var url = $state.href('editSalesInvoice', {
                        VoucherId: selectedData.SalesInvoiceId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Sales Invoice 2") {

                    var url = $state.href('editSalesInvoice2', {
                        VoucherId: selectedData.SalesInvoice2Id
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Sales Invoice 3") {

                    var url = $state.href('editSalesInvoice3', {
                        VoucherId: selectedData.SalesInvoice3Id
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Sales Invoice 4") {

                    var url = $state.href('editSalesInvoice4', {
                        VoucherId: selectedData.SalesInvoice4Id
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Sales Return") {

                    var url = $state.href('editSalesReturn', {
                        VoucherId: selectedData.SalesReturnId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Credit Note SR") {

                    var url = $state.href('editCreditNoteSR', {
                        VoucherId: selectedData.CreditNoteSRId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Purchase Invoice") {

                    var url = $state.href('editPurchaseInvoice', {
                        VoucherId: selectedData.PurchaseInvoiceId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Purchase Return") {
                    var url = $state.href('editPurchaseReturn', {
                        VoucherId: selectedData.PurchaseReturnId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Opening Balance") {

                    var url = $state.href('editOpeningBalance', {
                        VoucherId: selectedData.OpeningBalanceId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Fund Payment Voucher") {

                    var url = $state.href('editFPVMaster', {
                        VoucherId: selectedData.FPVId
                    });
                    $window.open(url, '_blank');



                } else if (selectedData.Type == "Fund Receipt Voucher") {

                    var url = $state.href('editFRVMaster', {
                        VoucherId: selectedData.FRVId
                    });
                    $window.open(url, '_blank');



                } else if (selectedData.Type == "Cash Payment Voucher") {

                    var url = $state.href('editCPVMaster', {
                        VoucherId: selectedData.CPVId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Cash Receipt Voucher") {

                    var url = $state.href('editCRVMaster', {
                        VoucherId: selectedData.CRVId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Cheque Payment Voucher") {

                    var url = $state.href('editChequePVMaster', {
                        VoucherId: selectedData.ChequePaymentId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Cheque Receipt Voucher") {

                    var url = $state.href('editChequeRVMaster', {
                        VoucherId: selectedData.ChequeReceiptId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Journal Voucher") {

                    var url = $state.href('editJVMaster', {
                        VoucherId: selectedData.JVId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Company Expense") {

                    var url = $state.href('editcompanyExpense', {
                        VoucherId: selectedData.CompanyExpenseId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Counter Sales") {

                    var url = $state.href('counterSalesEdit', {
                        VoucherId: selectedData.CounterSalesId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Counter Sales") {
                    //                $state.go("editPurchaseInvoice", {
                    //                    VoucherId: selectedData.
                    //                })
                }
                //            if (selectedData.Type == "Contract Invoice") {
                //                $state.go("editPurchaseInvoice", {
                //                    VoucherId: selectedData.
                //                })
                //            }
                else if (selectedData.Type == "Direct Sales Invoice") {
                    var url = $state.href('editDirSalesInvoice', {
                        VoucherId: selectedData.DirSalesInvoiceId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Direct Purchase Invoice") {
                    var url = $state.href('editDirPurchaseInvoice', {
                        VoucherId: selectedData.DirPurchaseInvoiceId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Export Sales Invoice") {

                    var url = $state.href('editExpSalesInvoice', {
                        VoucherId: selectedData.ExpSalesInvoiceId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Export Purchase Invoice") {

                    var url = $state.href('editExpPurchaseInvoice', {
                        VoucherId: selectedData.ExpPurchaseInvoiceId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Import Purchase Invoice") {

                    var url = $state.href('editImpPurchaseInvoice', {
                        VoucherId: selectedData.ImpPurchaseInvoiceId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Opening Stock") {

                    var url = $state.href('editOpeningStock', {
                        VoucherId: selectedData.OpeningStockId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Stock Issue") {

                    var url = $state.href('editStockIssue', {
                        VoucherId: selectedData.StockIssueId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Stock FOC") {

                    var url = $state.href('editStockFOC', {
                        VoucherId: selectedData.StockFOCId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.Type == "Stock Receive") {

                    var url = $state.href('editStockRecieve', {
                        VoucherId: selectedData.StockReceiveId
                    });
                    $window.open(url, '_blank');



                } else if (selectedData.Type == "Delivery Note") {

                    var url = $state.href('editDeliveryNote', {
                        VoucherId: selectedData.DeliveryNoteId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Stock JV") {

                    var url = $state.href('editStockJV', {
                        VoucherId: selectedData.StockJVId
                    });
                    $window.open(url, '_blank');


                }
                //                else if (selectedData.Type == "Porfoma Invoice") {
                //
                //                    var url = $state.href('editStockJV', {
                //                        VoucherId: selectedData.ProSalesInvoiceId
                //                    });
                //                    $window.open(url, '_blank');
                //
                //
                //                } 
                else if (selectedData.Type == "Individual Sales Invoice") {

                    var url = $state.href('editIndSalesInvoice', {
                        VoucherId: selectedData.IndSalesInvoiceId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.Type == "Individual Purchase Invoice") {

                    var url = $state.href('editIndPurchaseInvoice', {
                        VoucherId: selectedData.IndPurchaseInvoiceId
                    });
                    $window.open(url, '_blank');

                }
            }



        }])
